import { BaseCommand } from "./baseCommand.js";

export class TransformCommand extends BaseCommand {
  /**
   * transform操作的历史记录
   * @param {Object3D} obj 操作对象
   * @param {Object} oldState 操作之前的状态，包含position、scale、quaternion
   */
  constructor(obj, oldState, updateCB) {
    super();
    this.type = "TransformCommand";

    this.obj = obj;

    this.oldState = oldState;
    this.updateCB = updateCB;
    this.newState = {
      position: obj.position.clone(),
      scale: obj.scale.clone(),
      quaternion: obj.quaternion.clone(),
    };

    if (this.obj._type && this.obj._type === "uniformParent") {
      this.oldParent = this.obj;
      this.obj = this.obj.children[0];
    }
  }

  undo() {
    super.undo();
    if (this.obj && this.oldState) {
      let tempObj = this.obj;
      if (this.oldParent) tempObj = this.obj.parent;
      tempObj.position.copy(this.oldState.position);
      tempObj.scale.copy(this.oldState.scale);
      tempObj.quaternion.copy(this.oldState.quaternion);
      if (this.updateCB) this.updateCB();
    }
  }

  redo() {
    super.redo();
    if (this.obj && this.newState) {
      let tempObj = this.obj;
      if (this.oldParent) tempObj = this.obj.parent;
      tempObj.position.copy(this.newState.position);
      tempObj.scale.copy(this.newState.scale);
      tempObj.quaternion.copy(this.newState.quaternion);
      if (this.updateCB) this.updateCB();
    }
  }

  clear() {
    this.obj = null;
    this.oldState = null;
    this.newState = null;
    this.updateCB = null;
  }
}
